import { createFileRoute } from "@tanstack/react-router";
import { PasswordSettings } from "@/features/auth/components/password-settings";
export const Route = createFileRoute(
  "/_authenticated/_protected/settings/password",
)({
  component: PasswordPage,
});
function PasswordPage() {
  const { session } = Route.useRouteContext();
  return <PasswordSettings key={session.user.id} account={session.user} />;
}
